<template>
    <form id="form-password-change" v-on:submit.prevent="onPasswordChangeSubmit">
        <div class="form-group">
            <ejs-textbox v-model="data.oldPassword" name="oldPassword" floatLabelType="Auto" cssClass="e-outline" :placeholder="$t('textPassword.textFormOldPassword')" data-msg-containerid="formPasswordResetOldPassword"></ejs-textbox>
            <div id="formPasswordResetOldPassword"></div>
        </div>
        <div class="form-group">
            <ejs-textbox v-model="data.newPassword" name="newPassword" floatLabelType="Auto" cssClass="e-outline" :placeholder="$t('textPassword.textFormNewPassword')" data-msg-containerid="formPasswordResetNewPassword"></ejs-textbox>
            <div id="formPasswordResetNewPassword"></div>
        </div>
        <div class="form-group">
            <ejs-textbox v-model="data.repeatPassword" name="repeatPassword" floatLabelType="Auto" cssClass="e-outline" :placeholder="$t('textPassword.textFormRepeatPassword')" data-msg-containerid="formPasswordResetRepeatPassword"></ejs-textbox>
            <div id="formPasswordResetRepeatPassword"></div>
        </div>
        <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn">{{ $t('textBtn.btnSend') }}</ejs-progressbutton>
    </form>
</template>
<script>
import axios from 'axios'
export default {
    name: "password-change",
    data() {
        return {
            data: {
                oldPassword: '',
                newPassword: '',
                repeatPassword: '',
            },
            formObj: '',
            formOptions: {
                rules: {
                    'oldPassword': {	
                        required: [true, "* Campo requerido."]	
                    },
                    'newPassword': {	
                        required: [true, "* Campo requerido."]	
                    },
                    'repeatPassword': {	
                        required: [true, "* Campo requerido."]	
                    }
                }
            }
        }
    },
    mounted: function () {
        this.formObj = new FormValidator('#form-password-change', this.formOptions);
    },
    methods: {
        onPasswordChangeSubmit: function() {
            let formStatus = this.formObj.validate();
            if (formStatus) {
                axios.post('/auth/password/change', this.data).then(response => {
                    this.formObj.element.reset();
                    Vue.prototype.$eventHub.$emit('closeSidebarClick');
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                });
            }
        }
    }
}
</script>